import { useContext, type Context } from 'react';

export function useSafeContext<T>(providerName: string, Context: Context<T | undefined>) {
  const context = useContext(Context);
  if (context === undefined) throw new Error(`${providerName} not found in React tree`);
  return context;
}
